import { defineComponent, createVNode } from 'vue';
import { getValidChildren } from '../../utils.mjs';
import { useInputAddonStyles } from './useInputAddonStyles.mjs';

const {
  start
} = useInputAddonStyles();
const InputStartAddon = /* @__PURE__ */ defineComponent({
  setup(_, {
    slots
  }) {
    return () => createVNode("span", {
      "class": start
    }, {
      default: () => getValidChildren(slots)
    });
  }
});

export { InputStartAddon as default };
